import React, { useEffect, useState } from "react";
import "./MarketTape.css";

const SYMBOLS = [
  "SPY",
  "QQQ",
  "IWM",
  "DIA",
  "^VIX",
  "NQ=F",
  "ES=F",
  "GC=F",
  "CL=F",
  "BTC-USD",
];

const LABELS = {
  "^VIX": "VIX",
  "NQ=F": "NQ",
  "ES=F": "ES",
  "GC=F": "GOLD",
  "CL=F": "OIL",
  "BTC-USD": "BTC",
};

const formatPrice = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "--";
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const fromSearch = (payload, symbol) => {
  const ticker = Array.isArray(payload) ? payload[0] : null;
  if (!ticker || ticker.currentPrice == null) return null;
  const pct = Number(ticker.regularMarketChangePercent);
  return {
    symbol: ticker.ticker || symbol,
    label: LABELS[symbol] || ticker.ticker || symbol,
    price: ticker.currentPrice,
    change: ticker.regularMarketChange,
    changePercent: Number.isFinite(pct) ? pct * 100 : 0,
  };
};

const loadTape = async () => {
  try {
    const response = await fetch("/api/ticker/market-pulse");
    const data = await response.json();
    if (Array.isArray(data) && data.length && data[0].price != null) {
      return data;
    }
  } catch (error) {
    console.error(error);
  }

  const rows = await Promise.all(
    SYMBOLS.map(async (symbol) => {
      try {
        const response = await fetch(
          `/api/ticker/search-by-name?name=${encodeURIComponent(symbol)}`
        );
        return fromSearch(await response.json(), symbol);
      } catch (error) {
        return null;
      }
    })
  );
  return rows.filter(Boolean);
};

const MarketTape = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    const refresh = async () => {
      const next = await loadTape();
      if (active && next.length) setItems(next);
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, []);

  if (!items.length) return null;

  const loop = [...items, ...items];

  return (
    <div className="market-tape" aria-label="Live market">
      <div
        className="market-tape__track"
        style={{ animationDuration: `${Math.max(items.length * 4, 28)}s` }}
      >
        {loop.map((item, index) => {
          const change = Number(item.change || 0);
          const percent = Number(item.changePercent || 0);
          const up = change >= 0;
          return (
            <span className="market-tape__item" key={`${item.symbol}-${index}`}>
              <span className="market-tape__label">
                {item.label || item.symbol}
              </span>
              <span className="market-tape__price">${formatPrice(item.price)}</span>
              <span className={`market-tape__chg ${up ? "is-up" : "is-down"}`}>
                {up ? "▲" : "▼"} {up ? "+" : ""}
                {change.toFixed(2)} ({up ? "+" : ""}
                {percent.toFixed(2)}%)
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default MarketTape;
